export const _en = {
    dialog: {
        create: {
            title: "Create",
            save: ""
        },
        edit: {
            title: "Edit",
            save: "Save",
            cancel: "Cancel"
        },
        delete: {
            title: "Delete",
            save: "",
            cancel: ""
        },
        duplicate: {
            session: {
                title: "Duplication of a session",
                messageBody: "By confirming, you will duplicate the session \"{{sessionName}}\" without its associated resources.",
                messageBodyError: "The session \"{{sessionName}}\" is a briefing/debriefing session that cannot be duplicated."
            }
        },
        courseSession: {
            resourceAssignation: {
                title: "",
                prerequisiteSwitch: {
                    label: "Enable resource needs consideration"
                },
                recomandedAssignation: {
                    label: "Add the recommended resources"
                }
            },
            listView: {
                paramsTab: {
                    title: "Settings"
                },
                resourcesTab: {
                    title: "Assigned resources"
                }
            },
            propagateSwitch: {
                label: "Propagate changes to briefing and debriefing"
            }
        }
    },
    tooltip: {
        name: "Label",
        startHour: "Start",
        finishHour: "End",
        courses: {
            courseName: "Training course",
            sessionName: "Session"
        }
    },
    taskTypesSmartlist: {
        placeholder: "Activity types"
    },
    trainingCourseList: {
        placeholder: "Courses",
        emptyLabel: "None"
    },
    availabilityView: {
        dialog: {
            edit: {
                title: "Availability edit"
            },
            create: {
                title: "Availability create"
            },
            customPrefix: {
                prefix: "Custom"
            }
        },
        reserve: {
            errorMessage: {
                warningActivityPlanned: "Attention a session or activity is planned",
                blockedActivityPlanned: "The reserve cannot be positioned on a session during which an activity is already planned"
            }
        }

    },
    filterBarTitle: {
        planning: {
            label: "Planning view"
        },
        availability: {
            label: "Availability view"
        }
    },
    ConstructionPlanningIcon: {
        toolTip: "Turning date {{dateJalon}}"
    },
    taskCodeEventTab: {
        label: "Code event",
        title: "Manage code event",
        attribut: {
            codeEvent: "Code event",
            comment: "Comment",
            realDuration: "Real duration",
            durationTask: "Task duration"
        }
    }
};

export const _fr = {
    dialog: {
        create: {
            title: "Création d'une séance",
            save: "Créer"
        },
        edit: {
            title: "Édition d'une séance",
            save: "Sauvegarder",
            cancel: "Annuler",
            notSavedDummyTooltip: "Séance actuellement non sauvegardée.\nElle sera sauvegardée à partir du {{date}} si la récurrence n'est pas modifiée."
        },
        delete: {
            title: "Suppression d'une activité",
            save: "Sauvegarder",
            cancel: "Annuler"
        },
        duplicate: {
            session: {
                title: "Duplication d'une séance",
                messageBody: "En validant, vous allez dupliquer la séance  « {{sessionName}} » sans ses ressources associées.",
                messageBodyError: "La séance « {{sessionName}} » est une séance briefing/débriefing qui ne peut pas être dupliquée."
            }
        },
        courseSession: {
            update: {
                title: "Édition d'une séance",
                prerequisiteSwitch: {
                    label: "Activer la prise en compte des besoins en ressources"
                },
                recomandedAssignation: {
                    label: "Ajouter les ressources recommandées"
                }
            },
            listView: {
                paramsTab: {
                    title: "Paramètres",
                    tooltip: "Gestion des attributs de la séance"
                },
                resourcesTab: {
                    title: "Ressources assignées",
                    tooltip: "Gestion des besoins en ressources"
                },
                prerequisiteTab: {
                    title: "Prérequis",
                    tooltip: "Gestion des prérequis entre séances"
                }
            },
            propagateSwitch: {
                label: "Propager les changements au briefing et débriefing"
            }
        }
    },
    tooltip: {
        name: "Libellé",
        startHour: "Début",
        finishHour: "Fin",
        courses: {
            courseName: "Stage",
            sessionName: "Séance"
        }
    },
    taskTypesSmartlist: {
        placeholder: "Types d'activités"
    },
    trainingCourseList: {
        placeholder: "Stages",
        emptyLabel: "Aucun"
    },
    availabilityView: {
        dialog: {
            edit: {
                title: "Édition d'une plage de disponibilité"
            },
            create: {
                title: "Ajout d'une plage de disponibilité"
            },
            customPrefix: {
                prefix: "[Personnalisé]"
            }
        },
        reserve: {
            errorMessage: {
                warningActivityPlanned: "Attention une activité/séance est planifiée sur cette réserve",
                blockedActivityPlanned: "La réserve ne peut être positionnée sur une vacation durant laquelle une activité est déjà planifiée."
            }
        }

    },
    filterBarTitle: {
        planning: {
            label: "Vue planning"
        },
        availability: {
            label: "Vue disponibilité"
        }
    },
    ConstructionPlanningIcon: {
        toolTip: "Date jalon : {{dateJalon}}"
    },
    taskCodeEventTab: {
        label: "Codes évènements",
        tooltip: "Gestion des codes évènements",
        attribut: {
            codeEvent: "Codes évènements",
            comment: "Commentaire",
            realDuration: "Durée réel",
            durationTask: "Durée de la séance"
        }
    }
};